import { ErrorHandler, Injectable, NgZone } from "@angular/core";
import { ErrorDialogService } from "src/app/shared/components/error-dialog/error-dialog.service";
import { ToastService } from "../services/toast.service";

@Injectable()
export class LessonErrorHandler implements ErrorHandler {
  private urlsToIgnore: string[] = [
    "hash_empty_error",
    "/oath2/v2.0/token",
    "no_tokens_found",
    "monitor_window_timeout",
  ];
  private readonly authReloadGuardKey = "ell-auth-reload-attempted";

  constructor(
    private errorDialogService: ErrorDialogService,
    private zone: NgZone,
    private toastService: ToastService
  ) {}

  //temporarily leave spaghetti cases for debugging

  handleError(err: any): void {
    console.log("error verbosity: ", err);
    console.log("error verbosity msg: ", err.message);
    if (this.urlsToIgnore.some((url) => err.message.includes(url))) {
      const hasReloadedForAuth =
        sessionStorage.getItem(this.authReloadGuardKey) === "true";

      // Avoid infinite reload loops if auth cache recovery does not resolve the issue.
      if (!hasReloadedForAuth) {
        sessionStorage.setItem(this.authReloadGuardKey, "true");
        localStorage.clear();
        sessionStorage.removeItem("profile");
        sessionStorage.removeItem("profile-ell");
        sessionStorage.removeItem("name");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("uniqueKey");
        sessionStorage.removeItem("businessunit");
        sessionStorage.removeItem("roles");
        sessionStorage.removeItem("idtoken");
        console.log("cleared auth cache... reloading once...");
        window.location.reload();
      }
    }
  }
}
